import endpoints from 'constants/endpoints';
import {
  GET_DASHBOARD_DATA,
  UPDATE_LOADING_APPOINTMENTS_DATA,
  UPDATE_LOADING_DASHBOARD
} from 'constants/types';
import { ArrayToObject } from 'helpers/arrays';
import announcementFactory from 'helpers/factory/announcementFactory';
import noteFactory from 'helpers/factory/noteFactory';
import { safePostCall } from 'helpers/firebaseSetup';
import { getAppointmentsViewData } from './appointments';
import { siteLoaded } from './site';
import importantDatesFactory from 'helpers/factory/importantDatesFactory';
import ownerFactory from 'helpers/factory/ownerFactory';
import { isAgentRankLimited } from 'helpers/agents';
import { calendarEventFactory } from 'helpers/dashboard/calendar-events';

export const getDashboardData =
  (cancelTokenSource = {}) =>
  async (dispatch, getState) => {
    const { zohoId, zohoData: user } = getState().user;

    if (
      !getState()?.dashboard.announcements ||
      !getState()?.dashboard.notes ||
      !getState()?.dashboard.actionItems ||
      !getState()?.dashboard.importantDates ||
      !getState()?.dashboard.calendarEvents ||
      !getState()?.dashboard.owner ||
      !getState()?.appointments.carriers.Marketplace.length
    ) {
      const isAgentLimited = isAgentRankLimited(user.Rank);

      if (!isAgentLimited) {
        dispatch({
          type: UPDATE_LOADING_APPOINTMENTS_DATA,
          payload: true
        });
      }
      dispatch({
        type: UPDATE_LOADING_DASHBOARD,
        payload: true
      });
      safePostCall(
        endpoints.awsProxy.safePost,
        {
          zohoId,
          endpoint: endpoints.zoho.getDashboardData,
          isZohoRequest: true
        },
        {
          cancelToken: cancelTokenSource.token
        }
      )
        .then(res => {
          if (res) {
            const response = JSON.parse(res.data.details.output);

            const notes = ArrayToObject(
              response.notes.map(note => noteFactory(note))
            );

            const calendarEvents = (response.calendarEvents || []).map(event =>
              calendarEventFactory(event)
            );
            const importantDates = response.importantDates.map(item =>
              importantDatesFactory(item)
            );
            const ownerArray = response.owner.map(owner => ownerFactory(owner));
            const owner = ownerArray[0];

            dispatch({
              type: GET_DASHBOARD_DATA,
              payload: {
                announcements: response.announcements.map(announcement =>
                  announcementFactory(announcement)
                ),
                notes,
                importantDates,
                owner,
                calendarEvents
              }
            });

            dispatch(siteLoaded());
            //Gets the active appointments
            if (isAgentLimited) {
              // stop loader since it will not be updated in appointments view data
              dispatch({
                type: UPDATE_LOADING_DASHBOARD,
                payload: false
              });
            } else {
              // only call API if agent is not active
              dispatch(
                getAppointmentsViewData(
                  value =>
                    dispatch({
                      type: UPDATE_LOADING_DASHBOARD,
                      payload: value
                    }),
                  cancelTokenSource,
                  false
                )
              );
            }
          }
        })
        .catch(error => console.error(error));
    } else {
      dispatch(siteLoaded());
      dispatch({
        type: UPDATE_LOADING_DASHBOARD,
        payload: false
      });
    }
  };
